let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("eYGV1"), load("2i16i"), load("fSV9f"), load("78EJ0")]).then(() => parcelRequire('c0sxZ'));